package gr.tech.site.styles

import com.varabyte.kobweb.compose.css.functions.invert
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.*

val FaqLightAccordionStyle = CssStyle {
    cssRule(" .accordion-item") {
        Modifier
            .backgroundColor(Colors.White)
            .border(1.px, LineStyle.Solid, rgba(0, 0, 0, 0.12))
    }
    cssRule(" .accordion-button") {
        Modifier
            .backgroundColor(Colors.White)
            .color(Theme.DarkGreen.rgb)
            .fontWeight(600)
            .fontSize(1.cssRem)
    }
    cssRule(" .accordion-button:not(.collapsed)") {
        Modifier
            .backgroundColor(Theme.DarkGreen.rgb)
            .color(Colors.White)
    }
    cssRule(" .accordion-button:not(.collapsed)::after") {
        Modifier.filter(invert(100.percent))
    }
    cssRule(" .accordion-collapse") {
        Modifier.backgroundColor(Colors.White)
    }
    cssRule(" .accordion-body") {
        Modifier
            .color(rgba(0, 0, 0, 0.7))
            .fontSize(0.95.cssRem)
            .lineHeight(1.7)
    }
}
